import * as Tippy from 'tippy.js/dist/tippy.all.min.js';
var TooltipsService = /** @class */ (function () {
    function TooltipsService() {
    }
    TooltipsService.initTooltips = function () {
        return Tippy('[title]', {
            placement: 'top',
            animation: 'fade',
            duration: 750,
            arrow: true
        });
    };
    return TooltipsService;
}());
export { TooltipsService };



//////////////////
// WEBPACK FOOTER
// ./services/tooltips.service.ts
// module id = 5
// module chunks = 0